export type TextAlignment = "Default" | "Center";
export const TextAlignmentValues: TextAlignment[] = ["Default", "Center"];
